import { useEffect, useMemo, useState } from 'react'
import { TIMELINE_START_HOUR, TIMELINE_DURATION_MINUTES } from '../../../shared/lib/timeline'
import { TIMELINE_TECH_NAME_WIDTH } from '../../../shared/lib/timeline/useScrollToHour'

interface Props {
  dayIso: string
}

export const CurrentTimeIndicator = ({ dayIso }: Props) => {
  const [now, setNow] = useState(() => new Date())

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000)
    return () => clearInterval(id)
  }, [])

  const currentTimePct = useMemo(() => {
    const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
    if (dayIso !== todayStr) return null
    const minutes = now.getHours() * 60 + now.getMinutes()
    const pct = (minutes - TIMELINE_START_HOUR * 60) / TIMELINE_DURATION_MINUTES
    return pct >= 0 && pct <= 1 ? pct : null
  }, [now, dayIso])

  if (currentTimePct === null) return null

  return (
    <div
      className="absolute top-0 bottom-0 pointer-events-none z-30"
      style={{ left: `calc(${currentTimePct * 100}% + ${TIMELINE_TECH_NAME_WIDTH * (1 - currentTimePct)}px)` }}
    >
      <div className="absolute top-0 bottom-0 left-0 w-px bg-red-500" />
      <div className="absolute top-11 left-0 -translate-x-1/2 -translate-y-1/2 w-2.5 h-2.5 bg-red-500 rounded-full" />
    </div>
  )
}
